import React from "react";
import "./InsuranceBanner.css";

function ContactIcon(props) {
    const iconName = props.iconName;

    if (iconName === "phone") {
        return (
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.69 2.8a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.28-1.28a2 2 0 0 1 2.11-.45c.9.33 1.84.56 2.8.69A2 2 0 0 1 22 16.92z" />
            </svg>
        );
    }

    if (iconName === "email") {
        return (
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 6-10 7L2 6" />
            </svg>
        );
    }

    if (iconName === "location") {
        return (
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <path d="M21 10c0 7-9 12-9 12S3 17 3 10a9 9 0 1 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
            </svg>
        );
    }

    return null;
}

function InsuranceBanner() {
    return (
        <aside
            className="insuranceBanner"
            aria-label="Mobilito Ubezpieczenia"
        >
            <div className="insuranceBanner__top">
                <div className="insuranceBanner__brand">
                    <span className="insuranceBanner__monogram">M</span>

                    <div>
                        <div className="insuranceBanner__brandName">
                            <span>Mobilito</span> Ubezpieczenia
                        </div>

                        <div className="insuranceBanner__brandSubtitle">
                            Bezpiecznie. Prosto. Na dobrych warunkach.
                        </div>
                    </div>
                </div>

                <div className="insuranceBanner__partners">
                    <span className="partner partner--warta">
                        warta.
                    </span>

                    <span className="partner partner--hdi">
                        HDI
                    </span>

                    <span className="partner partner--unilink">
                        Unilink
                    </span>
                </div>
            </div>

            <div className="insuranceBanner__body">
                <div className="insuranceBanner__agent">
                    <span className="insuranceBanner__eyebrow">
                        Agent ubezpieczeniowy
                    </span>

                    <h2>Danuta Siedlaczek</h2>

                    <p>
                        Pomogę dobrać ubezpieczenie dopasowane do
                        Twoich potrzeb i przedstawię dostępne warianty
                        ochrony.
                    </p>
                </div>

                <div className="insuranceBanner__contact">
                    <a
                        href="tel:+48502754760"
                        className="insuranceBanner__contactItem"
                    >
                        <span className="insuranceBanner__icon">
                            <ContactIcon iconName="phone" />
                        </span>

                        <span>
                            <small>Zadzwoń</small>
                            <strong>502 754 760</strong>
                        </span>
                    </a>

                    <a
                        href="mailto:danuta@mobilito.eu?subject=Zapytanie%20o%20ubezpieczenie"
                        className="insuranceBanner__contactItem"
                    >
                        <span className="insuranceBanner__icon">
                            <ContactIcon iconName="email" />
                        </span>

                        <span>
                            <small>Napisz wiadomość</small>
                            <strong>danuta@mobilito.eu</strong>
                        </span>
                    </a>

                    <div className="insuranceBanner__contactItem">
                        <span className="insuranceBanner__icon">
                            <ContactIcon iconName="location" />
                        </span>

                        <span>
                            <small>Odwiedź nas</small>
                            <strong>
                                43-392 Międzyrzecze Górne 370
                            </strong>
                        </span>
                    </div>
                </div>
            </div>

            <div className="insuranceBanner__bottom">
                <span>
                    Ubezpieczenia dla Ciebie, rodziny i firmy
                </span>

                <a
                    href="tel:+48502754760"
                    className="insuranceBanner__cta"
                >
                    Zapytaj o ofertę
                    <span aria-hidden="true">→</span>
                </a>
            </div>
        </aside>
    );
}

export default InsuranceBanner;
